import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  login as loginAction,
  logout as logoutAction,
  forgotPassword as forgotPasswordAction,
  updateProfile as updateProfileAction,
  changePassword as changePasswordAction,
  clearError as clearErrorAction,
} from '../store/slices/authSlice';
import type { ProfileUpdateData, ChangePasswordData } from '../store/slices/authSlice';

export const useAuth = () => {
  const dispatch = useDispatch<any>();
  const user = useSelector((state: any) => state.auth.user);
  const isAuthenticated = useSelector((state: any) => state.auth.isAuthenticated);
  const isLoading = useSelector((state: any) => state.auth.isLoading);
  const error = useSelector((state: any) => state.auth.error);

  const login = useCallback(async (email: string, password: string) => {
    const result = await dispatch(loginAction({ email, password })).unwrap();
    return result;
  }, [dispatch]);

  const logout = useCallback(async () => {
    await dispatch(logoutAction()).unwrap();
  }, [dispatch]);

  const sendForgotPassword = useCallback(async (email: string) => {
    const result = await dispatch(forgotPasswordAction(email)).unwrap();
    return result;
  }, [dispatch]);

  const updateProfile = useCallback(async (data: ProfileUpdateData) => {
    const result = await dispatch(updateProfileAction(data)).unwrap();
    return result;
  }, [dispatch]);

  const changePassword = useCallback(async (data: ChangePasswordData) => {
    const result = await dispatch(changePasswordAction(data)).unwrap();
    return result;
  }, [dispatch]);

  const clearError = useCallback(() => {
    dispatch(clearErrorAction());
  }, [dispatch]);

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    sendForgotPassword,
    updateProfile,
    changePassword,
    clearError,
  };
};